import { Component, OnInit, Input, AfterViewInit, ViewChild } from '@angular/core';
import { MatExpansionPanel } from '@angular/material/expansion';
import { PlanDetailsService } from '../../plan-details.service';
import { PlanDetailsRenderableCategory } from '../../types/plan-details.types';

@Component({
    selector: 'app-benefit-category',
    templateUrl: './benefit-category.component.html',
    styleUrls: ['./benefit-category.component.scss'],
    standalone: false
})
export class BenefitCategoryComponent implements OnInit, AfterViewInit {

  @Input() benefitCategory: PlanDetailsRenderableCategory;
  @Input() market: string;
  @Input() isFirstRow: boolean;

  @ViewChild(MatExpansionPanel) panel: MatExpansionPanel;

  constructor(private planDetailsService: PlanDetailsService) { }

  ngAfterViewInit(): void {
    if (this.isFirstRow) {
      setTimeout(() => this.panel.open() );
    }
  }

  ngOnInit(): void {}

  emitToggle(): void {
    setTimeout(() => this.planDetailsService.drawerToggled() );
  }

  togglePanel() {
    this.panel.toggle();
  }

}
